import {
  subscriptionApiKeys,
  useSubscriptionApi,
} from '@hooks/api/account/useSubscriptionApi';
import { useGetApi } from '@hooks/api/useGetApi';
import type { GetApiOptions } from 'types/api';
import type { PaymentMethod } from 'types/checkout';

export function useGetPaymentMethods(
  organizationId: string,
  {
    enabled = true,
    ...options
  }: Partial<GetApiOptions<PaymentMethod[], Error>> = {}
) {
  const api = useSubscriptionApi();

  const { data, ...result } = useGetApi({
    enabled: !!organizationId && enabled,
    queryKey: subscriptionApiKeys.getPaymentMethods(organizationId),
    request: () => api.getPaymentMethods(organizationId),
    ...options,
  });

  return {
    ...result,
    defaultPaymentMethod:
      data?.find((paymentMethod) => paymentMethod.isDefault) ?? data?.[0],
    paymentMethods: data ?? [],
  };
}
